import { axios, transformAxiosError } from "@/utils/axios.create";
import {
  NotifyClosurePayload,
  NotifyClosureResponse,
  SaveClosurePayload,
  SaveSchedulePayload,
  SiteOfficeClosure,
  SiteOfficeHoursSchedule,
} from "@/domain/site-office-hours.interface";

const getSchedule = async (
  programId: string,
  orgUnitId: string
): Promise<SiteOfficeHoursSchedule | null> => {
  return axios
    .get("/site-office-hours/schedule", { params: { programId, orgUnitId } })
    .then((res) => res.data.body)
    .catch((err) => Promise.reject(transformAxiosError(err)));
};

const saveSchedule = async (
  payload: SaveSchedulePayload
): Promise<SiteOfficeHoursSchedule> => {
  return axios
    .put("/site-office-hours/schedule", payload)
    .then((res) => res.data.body)
    .catch((err) => Promise.reject(transformAxiosError(err)));
};

const getActiveClosure = async (
  programId: string,
  orgUnitId: string
): Promise<SiteOfficeClosure | null> => {
  return axios
    .get("/site-office-hours/closure", { params: { programId, orgUnitId } })
    .then((res) => res.data.body)
    .catch((err) => Promise.reject(transformAxiosError(err)));
};

const saveClosure = async (
  payload: SaveClosurePayload
): Promise<SiteOfficeClosure> => {
  return axios
    .put("/site-office-hours/closure", payload)
    .then((res) => res.data.body)
    .catch((err) => Promise.reject(transformAxiosError(err)));
};

const notifyClosure = async (
  payload: NotifyClosurePayload
): Promise<NotifyClosureResponse> => {
  return axios
    .post("/site-office-hours/closure/notify", payload)
    .then((res) => res.data.body)
    .catch((err) => Promise.reject(transformAxiosError(err)));
};

export const siteOfficeHoursService = {
  getSchedule,
  saveSchedule,
  getActiveClosure,
  saveClosure,
  notifyClosure,
};
